import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export interface PasswordStrengthError {
  hasMinLength: boolean;
  hasUppercase: boolean;
  hasNumber: boolean;
  hasSpecialCharacter: boolean;
}

export function passwordStrengthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.value as string | null;

    if (!password) {
      return null;
    }

    const hasMinLength = password.length >= 10;
    const hasUppercase = /[A-Z]/.test(password);
    const hasNumber = /\d/.test(password);
    const hasSpecialCharacter = /[.,!@#$%^&*?(){}\\[\]|_<>]/.test(password);

    if (hasMinLength && hasUppercase && hasNumber && hasSpecialCharacter) {
      return null;
    }

    return {
      passwordStrength: {
        hasMinLength,
        hasUppercase,
        hasNumber,
        hasSpecialCharacter,
      } satisfies PasswordStrengthError,
    };
  };
}
